import React from 'react';
import { Box, Form, ResponsiveGrid } from '@fpxfd/next';
import { FpxDetailProps } from './index.interface';
import styles from './index.module.scss';

const { Cell } = ResponsiveGrid;

const FpxDetail = ({ title, button, colSpan = 5, gap, columns, items, dataSource = {}, children }: FpxDetailProps) => {
  const dealData = (data: any) => {
    if (data === 0) {
      return '0';
    }
    return data || '-';
  };

  const isObject = (obj: any) => Object.prototype.toString.call(obj) === '[object Object]'; // "[object Object]"

  const walkChildren = (nodes: any, arr: any[] = []) => {
    if (!nodes) {
      return arr;
    }
    if (Array.isArray(nodes)) {
      for (let i = 0; i < nodes.length; i++) {
        const el = nodes[i];
        arr.push(el);
        const isObj = isObject(el);
        if (isObj && el.props && el.props.children) {
          walkChildren(el.props.children, arr);
        }
      }
    } else {
      arr.push(nodes);
      const isObj = isObject(nodes);
      if (nodes && isObj && nodes.props && nodes.props.children) {
        walkChildren(nodes.props.children, arr);
      }
    }
    return arr;
  };
  const allNodes = walkChildren(children);

  const findSlot: any = (slotName: string, value?: string, record?: any) => {
    if (allNodes.length === 0) {
      return value;
    }
    const slotNode = allNodes.find((e) => isObject(e) && e.props && e.props.slot === slotName);
    if (slotNode) {
      return slotNode.props['data-cell'] ? slotNode.props['data-cell'](value, record) : slotNode;
    } else {
      return value;
    }
  };

  const renderChild = (e: any, dataSource: any) => {
    if (e.slot) {
      // console.log(findSlot(e.slot, dataSource[e.dataIndex], dataSource));
      return findSlot(e.slot, dataSource[e.dataIndex], dataSource);
    }
    if (e.transform) {
      return e.transform(dataSource[e.dataIndex], dataSource) || '-';
    }
    return dealData(dataSource[e.dataIndex]);
  };

  return (
    <div className={`${styles.FpxDetail} fpx-detail`} data-i18n-ignore-content>
      <Box className={styles.title} justify="space-between" direction="row" align="center">
        <span>{title}</span>
        {button}
      </Box>
      <Form labelAlign="top">
        <ResponsiveGrid columns={columns || 25} gap={gap || [0, 24]}>
          {items
            .filter((e) => !e.hidden)
            .map((e, i) => (
              <Cell colSpan={e.colSpan || 6} key={i}>
                <Form.Item label={<>{e.label}:</>} key={e.dataIndex} className={styles.label} title={e.label}>
                  <span className={`${styles.value} next-form-preview`}>{renderChild(e, dataSource)}</span>
                </Form.Item>
              </Cell>
            ))}
        </ResponsiveGrid>
      </Form>
    </div>
  );
};

export default FpxDetail;
